import React, { useEffect, useState } from "react";
import axios from "axios";
import { Label } from "reactstrap";
import { routes } from "./General";
import moment from "moment";
import { useUser } from "../custom-hooks/useUser";

export const DatosAsegurado = () => {
    const user = useUser();
    const [item, setItem] = useState({ us: [] });

    useEffect(() => {
        fetchData();
    }, [user.cedula]);

    function fetchData() {
        axios
            .get(routes.api + "/usuario", {
                params: {
                    ci: user.cedula,
                },
            })
            .then(resp => {
                let usuario = resp.data;
                usuario.fC = usuario.fC ? new Date(usuario.fC) : null;
                setItem(usuario);
            })
            .catch(console.log);
    }

    const estadoCivil = est => {
        let ret;
        switch (est) {
            case "V":
                ret = "VIUDO(A)";
                break;
            case "U":
                ret = "UNION LIBRE";
                break;
            case "D":
                ret = "DIVORCIADO(A)";
                break;
            case "C":
                ret = "CASADO(A)";
                break;
            case "A":
                ret = "A";
                break;
            case "S":
                ret = "SOLTERO(A)";
                break;
            case "E":
                ret = "EN RELACIÓN";
                break;
            default:
                ret = " ";
                break;
        }
        return ret;
    };
    const genero = gen => {
        let ret;
        switch (gen) {
            case "M":
                ret = "MASCULINO";
                break;
            case "F":
                ret = "FEMENINO";
                break;
            case "S":
                ret = "SIN DEFINIR";
                break;
            default:
                ret = " ";
                break;
        }
        return ret;
    };

    return (
        <div className={"col-md-8"}>
            <div className={"row"}>
                <div className="col-12 col-md-6">
                    <div className="row">
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Cédula/RUC:&nbsp;</Label>
                        </div>
                        <div className="col-6">
                            <span>{item.cedula}</span>
                        </div>
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Nombre:&nbsp;</Label>
                        </div>
                        <div className="col-6">
                            <span>{item.nmCliente}</span>
                        </div>
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Apellido:&nbsp;</Label>
                        </div>
                        <div className="col-6">
                            <span>{item.apCliente}</span>
                        </div>
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Género:&nbsp;</Label>
                        </div>
                        <div className="col-6">
                            <span>{genero(item.genero)}</span>
                        </div>
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Celular:&nbsp;</Label>
                        </div>
                        <div className="col-6">
                            <span>{item.celular}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="row">
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Estado Civil:&nbsp;</Label>
                        </div>
                        <div className="col-6">
                            <span>{estadoCivil(item.estadoCivil)}</span>
                        </div>
                        {item.estadoCivil === "C" && (
                            <>
                                <div className="col-6 text-right">
                                    <Label className="font-weight-bold">Nombre Cónyuge:&nbsp;</Label>
                                </div>
                                <div className="col-6">
                                    <span>
                                        {item.nmConyuge} {item.apConyuge}
                                    </span>
                                </div>
                                <div className="col-6 text-right">
                                    <Label className="font-weight-bold">Fc. Nacimiento:&nbsp;</Label>
                                </div>
                                <div className="col-6">
                                    <span>
                                        {moment(item.fcNacimiento).locale("moment/locale/es").format("DD/MM/YYYY")}
                                    </span>
                                </div>
                            </>
                        )}
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Título:&nbsp; </Label>
                        </div>
                        <div className="col-6">
                            <span>{item.titulo}</span>
                        </div>
                        <div className="col-6 text-right">
                            <Label className="font-weight-bold">Correo:&nbsp; </Label>
                        </div>
                        <div className="col-6">
                            <span>{item.correo}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
